import { createContext, useContext } from 'react'
import type { ThemeMode } from '@mysaiva/core'

export const THEME_MODE_STORAGE_KEY = 'mysaiva-developer-platform-theme'

export interface ModeContextValue {
  mode: ThemeMode
  setMode: (mode: ThemeMode) => void
  toggleMode: () => void
}

export const ModeContext = createContext<ModeContextValue | null>(null)

export function useThemeMode(): ModeContextValue {
  const ctx = useContext(ModeContext)
  if (!ctx) throw new Error('useThemeMode must be used inside <ModeProvider>')
  return ctx
}
